var map = {
	"./CE-MR.pdf": 8168,
	"./CE-MRL.pdf": 3484,
	"./Steel_Rope_Test_certificate.pdf": 1547,
	"./Steel_rope_mill's_quality.pdf": 5089,
	"./Test report.pdf": 7562,
	"./steel_rope_certificate.pdf": 2684
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 647;